// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fuel-contamination.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fuel-contamination/fuel-contamination-prevention.js';
import g1 from '../lessons/aeronautics/fuel-contamination/fuel-contamination.js';

mount([g0, g1]);
